import Company from './Company';
export { Company };



//////////////////
// WEBPACK FOOTER
// ./src/app/guest/index.ts
// module id = 1256
// module chunks = 0